function saveTopic(sess, topic) {
    const {Topic} = sess;
    Topic.create(topic);
}

function removeTopic(sess, id) {
    const {Topic} = sess;
    const target = Topic.withId(id);
    target.discussions.delete();
    target.delete();
}

function removeTopics(sess) {
    const {Topic, List} = sess;
    const discussionList = List.getByName('discussions');
    if (discussionList) {
        discussionList.delete();
    }
    Topic.all().toModelArray().forEach(tm => {
        tm.discussions.delete();
        tm.delete();
    });
}


export default {
    saveTopic,
    removeTopic,
    removeTopics
}